// extracted by mini-css-extract-plugin
module.exports = {"contactsBox":"Contacts_contactsBox__dlglv","contacts":"Contacts_contacts__1XL13","contactsItem":"Contacts_contactsItem__1wwFG"};